import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import { urlFromLocationName } from '../_Components/addUrlToLocation.js'
import ImageWithSkeleton from '../../../../../../components/ImageWithSkeleton'
import { legacyNoticeLines } from './notices'
import { useTranslation, Trans } from 'react-i18next'

const NOTICE_ICONS = {
  info: { Icon: InfoIcon, color: 'info.main' },
  warning: { Icon: WarningIcon, color: 'warning.main' }
}

export default function DropBagInfo ({ race, distance }) {
  const { t } = useTranslation('raceGuide')
  const details = race?.raceDistances.find(d => d.distance === distance)
  const locations = race?.locations

  if (!details?.dropBagInfo) {
    return (
      <Typography
        sx={{
        color: 'text.secondary'
      }}
      >{t('dropBag.noService')}</Typography>
    )
  }
  const bags = details?.dropBagInfo
  const notices = Array.isArray(bags.notices) && bags.notices.some(n => n?.text)
    ? bags.notices
    : legacyNoticeLines(bags.collectionInfo)
  const dropLocations = bags.locations?.filter(l => l.validFor?.includes(distance)) || []

  return (
    <Box sx={{ maxWidth: '100%', mx: 'auto' }}>
      <Card elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <CardContent>
          <Box sx={{ mb: 3 }}>
            <Box>
              <Trans
                ns='raceGuide'
                i18nKey='dropBag.generalInfo'
                values={{
                  participants: bags.generalInfo.participants,
                  bagType: bags.generalInfo.bagType,
                  capacity: bags.generalInfo.capacity
                }}
                components={{ 1: <strong />, 2: <Chip size='small' />, 3: <Chip size='small' /> }}
              />
            </Box>

            <Typography sx={{ mt: 2 }}>
              <Trans
                ns='raceGuide'
                i18nKey='dropBag.restrictions'
                values={{ restrictions: bags.generalInfo.restrictions }}
                components={{ 1: <WarningIcon sx={{ fontSize: 'small', verticalAlign: 'middle', mx: 1, color: 'warning.main' }} />, 2: <strong /> }}
              />
            </Typography>

            <Typography>
              {bags.generalInfo.bibInstruction}
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />
          {bags.image && (
            <Box sx={{ display: 'flex', my: 3 }}>
              <ImageWithSkeleton
                src={bags.image}
                maxWidth='112px'
                square
                oneSize
                imageSx={{ borderRadius: 2 }}
              />
            </Box>
                        )}

          <Typography variant='h6' component='h3' sx={{ fontWeight: 'bold' }}>
            {t('dropBag.locationsTitle')}
          </Typography>

          <List sx={{ mb: 3 }}>
            {dropLocations.map((location) => (
              <ListItem key={location.id}>
                <ListItemIcon>
                  <LocationOnIcon />
                </ListItemIcon>
                <ListItemText
                  primary={location.title || location.locationName || location.description}
                  secondary={urlFromLocationName(locations, location.locationName || location.description)}
                  sx={{
                    '& .MuiListItemText-primary': { fontWeight: 'bold' },
                    '& .MuiListItemText-secondary': { fontSize: '1.1rem' }
                  }}
                />
              </ListItem>
            ))}
          </List>

          {notices.length > 0 && (
            <Box sx={{ backgroundColor: '#373737ff', p: 2, borderRadius: 2, mb: 3 }}>
              {notices.map((notice, i) => {
                const { Icon, color } = NOTICE_ICONS[notice.icon] || NOTICE_ICONS.info
                return (
                  <Typography key={i} sx={{ mb: 1 }}>
                    <Icon sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1, color }} />
                    {urlFromLocationName(locations, notice.textKey ? t(notice.textKey, notice.textVars) : notice.text)}
                  </Typography>
                )
              })}
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}